// THIS FILE IS AUTOMATICALLY GENERATED BY SPACETIMEDB. EDITS TO THIS FILE
// WILL NOT BE SAVED. MODIFY TABLES IN YOUR MODULE SOURCE CODE INSTEAD.

/* eslint-disable */
/* tslint:disable */
import {
  TypeBuilder as __TypeBuilder,
  t as __t,
  type AlgebraicTypeType as __AlgebraicTypeType,
  type Infer as __Infer,
} from "spacetimedb";

export default __t.row({
  haulId: __t.u64().primaryKey().name("haul_id"),
  portId: __t.u64().name("port_id"),
  direction: __t.string(),
  civ: __t.string(),
  yardFirmId: __t.u64().name("yard_firm_id"),
  stationKey: __t.string().name("station_key"),
  qty: __t.u32(),
  captain: __t.identity(),
  deliveredBy: __t.identity().name("delivered_by"),
  custodianRev: __t.u32().name("custodian_rev"),
  termsVersion: __t.u32().name("terms_version"),
  splitRev: __t.u32().name("split_rev"),
  rewardSov: __t.i64().name("reward_sov"),
  payoutJson: __t.string().name("payout_json"),
  payTxId: __t.u64().name("pay_tx_id"),
  oreQuote: __t.i64().name("ore_quote"),
  orePaid: __t.i64().name("ore_paid"),
  yardOreAfter: __t.u32().name("yard_ore_after"),
  yardHulls: __t.u32().name("yard_hulls"),
  yardTarget: __t.u32().name("yard_target"),
  shortHours: __t.u32().name("short_hours"),
  acceptedAt: __t.timestamp().name("accepted_at"),
  deliveredAt: __t.timestamp().name("delivered_at"),
  stage: __t.string(),
  wait: __t.string(),
  builtAt: __t.timestamp().name("built_at"),
  reserveAt: __t.timestamp().name("reserve_at"),
  reserveHulls: __t.u32().name("reserve_hulls"),
  hullsSeen: __t.u32().name("hulls_seen"),
  campaignId: __t.u64().name("campaign_id"),
  committed: __t.u32(),
  checkedAt: __t.timestamp().name("checked_at"),
  updatedAt: __t.timestamp().name("updated_at"),
});
